import { Entidad } from "./entidad";
import { Item } from "./item";
import { TipoGarantia } from "./tipo-garantia";
import { TipoMoneda } from "./tipo-moneda";
import { TipoValidez } from "./tipo-validez";
import { TipoPago } from "./tipo-pago";
import { TipoEntrega } from "./tipo-entrega";
import { Competidor } from "./competidor";
import { Usuario } from "./usuario";
import { TipoImpuesto } from "./tipo-impuesto";
import { TipoCondicion } from "./tipo-condicion";

export interface TipoCotizacion {
  IdTipo?: number | string;
  descripcion?: string;
}

export interface EstadoCotizacion {
  IdEstado?: number | string;
  descripcion?: string;
}

export class Cotizacion {

  constructor(
    public IdCotizacion: number | string = null,
    public fechaAlta: string = '',
    public entidad: Entidad = new Entidad(),
    public tipoCotizacion: TipoCotizacion = {},
    public detalle?: string,
    public items: Item[] = <Item[]>[],
    public tipoEntrega: TipoEntrega = new TipoEntrega(),
    public estado: EstadoCotizacion = null,
    public total: number = 0,
    public tipoGarantia: TipoGarantia = new TipoGarantia(),
    public condiciones = <TipoCondicion[]>[],
    public obra: string = '',
    public fechaVencimiento: string = '',
    public horaVencimiento: string = '',
    public estadoMotivo: string = '',
    public destinoEntrega: string = '',
    public tipoMoneda: TipoMoneda = new TipoMoneda(),
    public tipoPago: TipoPago = new TipoPago(),
    public tipoValidez: TipoValidez = new TipoValidez(),
    public tipoImpuesto: TipoImpuesto[] = <TipoImpuesto[]>[],
    public fechaApertura: string = '',
    public editable: boolean = false,
    public created_by: string = '',
    public numero: number = null,
    public fechaHoraModificacion: string = '',
    public competidor: Competidor = new Competidor(),
    public vecesModificada: number = null,
    public responsable: Usuario = new Usuario,
    public alMenosUnArchivo: boolean = false,
    public observaciones_venta: string = "",
    public motivo_venta_rechazada: string = "",
    public propuesta: number = null,
  ) { }

  /**
   * Busca la condicicion y se fija si la encuentra
   * @param condicion     
   * @returns boolean true si contiene el dato buscado, false otro caso
   */
  hasCondicion(condicion: TipoCondicion) {
    var index = this.condiciones.length;
    while (index--) {
      if (this.condiciones[index].id == condicion.id) {
        return true;
      }
    }

    return false;
  }

  /**
   * @returns string con el texto de una condicion
   */
  getTextoCondicion(condicion: TipoCondicion): string {
    var index = this.condiciones.length;
    while (index--) {
      if (this.condiciones[index].id == condicion.id) {
        return this.condiciones[index].texto ? this.condiciones[index].texto : '';
      }
    }

    return '';
  }
}